/**
=========================================================
* ClubOS - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// ClubOS Base Styles
import colors from "assets/theme/base/colors";
import { SCROLLBAR } from "config/branding";

const { info, dark } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
    scrollbarWidth: "thin",
    scrollbarColor: `${SCROLLBAR.thumb} ${SCROLLBAR.track}`,
  },
  "::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
  },
  "::-webkit-scrollbar-track": {
    background: SCROLLBAR.track,
  },
  "::-webkit-scrollbar-thumb": {
    background: SCROLLBAR.thumb,
    borderRadius: "3px",
  },
  "::-webkit-scrollbar-thumb:hover": {
    background: SCROLLBAR.thumbHover,
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
};

export default globals;
